<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
			<template v-if="is_completed_step">
				<ul class="steps__step-summary">
					<li v-if="selected_business_development_leads.length">
						Business Development Lead:
						<span>
							<template
								v-for="item, index in selected_business_development_leads"
								:key="'business-dev-leads-' + index"
							>
								{{ item.label + ( index < selected_business_development_leads.length - 1 ? ', ' : '' ) }}
							</template>
						</span>
					</li>
					<li v-if="selected_project_managers.length">
						Project Manager:
						<span>
							<template
								v-for="item, index in selected_project_managers"
								:key="'project-managers-' + index"
							>
								{{ item.label + ( index < selected_project_managers.length - 1 ? ', ' : '' ) }}
							</template>
						</span>
					</li>
				</ul>
			</template>
		</div>
		<button
			v-if="is_completed_step"
			class="button button--smaller"
			type="button"
			@click="setActiveStep( step.step_number )"
		>
			Edit
		</button>
		<template v-else-if="is_current_step">
			<InternalTeamFormComponent
				:step-title="step.title"
			/>
		</template>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import InternalTeamFormComponent from './InternalTeamFormComponent';

const new_project_store = useNewProjectStore();

const {
	setActiveStep
} = new_project_store;

const {
	selected_business_development_leads,
	selected_project_managers
} = storeToRefs( new_project_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );
</script>
